import userAuthTriggerService from './userAuthTriggerService'

export default userAuthTriggerService
